import * as React from 'react';
import { useState } from "react";
import { Spinner } from "reactstrap";
import * as XLSX from "xlsx";
import { ButtonBrand, gold } from '../../../../getLPTheme';
import DownloadIcon from '@mui/icons-material/Download';
import { Box } from '@mui/material';

const BotonExcelDefault = ({ users }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);

    const libro = XLSX.utils.book_new();

    const hoja = XLSX.utils.json_to_sheet(users);

    XLSX.utils.book_append_sheet(libro, hoja, "users");

    setTimeout(() => {
      XLSX.writeFile(libro, "UsersWGC.xlsx");
      setLoading(false);
    }, 1000);
  };

  return (
    <>
      {!loading ? (
        <Box>
          <Box sx={{display: 'flex'}}>
            <ButtonBrand sx={{m:1, color: "white", backgroundColor: gold[500]}} onClick={handleDownload} type='submit' color='primary' variant="contained" fullWidth>
              <DownloadIcon/> Exportar Usuarios a Excel
            </ButtonBrand>
          </Box>
        </Box>
      ) : (
        <Box sx={{display: 'flex'}}>
          <ButtonBrand sx={{m:1, color: "white", backgroundColor: gold[500]}} type='submit' color='primary' variant="contained" fullWidth>
            <Spinner size="sm">Loading...</Spinner>
          </ButtonBrand>
        </Box>
      )}
    </>
  );
};

export default BotonExcelDefault;
